import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import { mapGetters, mapState } from 'vuex';
import { OneTimePassRoutesMixin } from '@/portal/one-time-pass/mixins';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    OneTimePassRoutesMixin,
  ],
  props: {
    completed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('oneTimePass', ['filteredAssessmentFields', 'workerInductions']),
    ...mapGetters('oneTimePass', {
      clientName: 'oneTimePassClientName',
    }),
    ...mapState('oneTimePass', ['workerOneTimePass']),
    criteriaItems() {
      const assessmentSectionCriterion = {
        title: `${this.clientName} Pre-assessment`,
        content: `A quick questionnaire about the services your provide to ${this.clientName}.`,
        status: this.workerOneTimePass.assessment_status,
      };
      const inductionsCriteria = this.workerInductions.map(workerInduction => ({
        title: workerInduction.name,
        content: `Required for individuals servicing ${this.clientName}.`,
        status: workerInduction.current_status,
      }));
      return [
        ...(this.filteredAssessmentFields.length ? [assessmentSectionCriterion] : []),
        ...inductionsCriteria,
      ];
    },
    headingText() {
      return this.completed ? `You're all done` : 'Well done, your pre-assessment is complete';
    },
    subheadingText() {
      return this.completed ? 'Here is a summary of your application' : 'Based on your assessment, you will be required to meet the following criteria';
    },
  },
  methods: {
    onNextClick() {
      this.$router.push(this.completed ? this.routes.success : this.routes.induction);
    },
    onPreviousClick() {
      const lastInduction = this.workerInductions.slice(-1)[0];
      const lastAssessmentField = this.filteredAssessmentFields.slice(-1)[0];
      if (this.completed && lastInduction) {
        this.$router.push(_.merge({}, this.routes.induction, {
          params: { inductionUuid: lastInduction.uuid },
        }));
      } else {
        this.$router.push(_.merge({}, this.routes.assessment, {
          params: { assessmentFieldUuid: lastAssessmentField.uuid },
        }));
      }
    },
    stepColour(status) {
      const mapping = {
        default: 'orange darken-1',
        completed: 'success',
        compliant: 'success',
        invited: 'grey',
        non_compliant: 'grey',
        submitted: 'grey',
      };
      return mapping[status] || mapping.default;
    },
    stepIcon(status) {
      const mapping = {
        default: 'far fa-circle',
        completed: 'fas fa-check',
        compliant: 'fas fa-check',
      };
      return mapping[status] || mapping.default;
    },
  },
};
